const translation: Record<string, string> = {
  "nav.brand": "OOPBUY",
  "nav.brand_sub": "Spreadsheets",
  "nav.home": "Home",
  "nav.shopping_guide": "Shopping Guide",
  "nav.guide_heading": "SEO Articles & Guides",
  "nav.dropdown_placeholder": "Browse Categories",
  "nav.btn_oopbuy": "oopbuy spreadsheet",
  "nav.btn_buy": "buy it now",
  "hero.badge": "OOPBUY Official Tool",
  "hero.title_line1": "OOPBUY",
  "hero.title_line2": "Spreadsheet",
  "hero.title_line3": "Sourcing System",
  "hero.description": "Streamline your product sourcing workflow with smart spreadsheets. Find, compare, and organize suppliers — all in one place.",
  "hero.cta_primary": "Try OOPBUY Spreadsheet",
  "hero.cta_secondary": "Explore Categories",
  "features.title": "Curated Product Categories",
  "categories.title": "All 14 Categories",
  "categories.subtitle": "Browse our complete catalog of spreadsheet-powered sourcing categories",
  "cta.title_line1": "Ready to",
  "cta.title_line2": "Scale Up?",
  "cta.description": "Thousands of dropshippers and e-commerce entrepreneurs use OOPBUY Spreadsheet to manage sourcing, track suppliers, and grow their business faster than ever.",
  "cta.button": "Start Using Now →",
  "testimonial.quote": "OOPBUY Spreadsheet completely transformed how I source products. I went from managing 50 SKUs in messy Excel files to handling 500+ SKUs effortlessly. The supplier comparison feature alone saved me 15 hours a week.",
  "testimonial.name": "Marcus Chen",
  "testimonial.role": "E-commerce Entrepreneur, LA",
  "testimonial.cta": "See Verified Results",
  "seo.tagline": "Why OOPBUY Spreadsheet?",
  "seo.title": "The Smarter Way to Manage Product Sourcing",
  "seo.paragraph1": "OOPBUY Spreadsheet is a purpose-built sourcing and inventory management tool designed for modern e-commerce entrepreneurs. Unlike generic spreadsheet software, it comes pre-configured with supplier comparison templates, bulk order calculators, and real-time profit margin tracking — everything you need to run a lean, profitable operation.",
  "seo.paragraph2": "Whether you are sourcing shoes from multiple factories, comparing hoodie suppliers across platforms, or organizing accessory shipments, OOPBUY Spreadsheet keeps every data point connected and actionable. No more copy-pasting between tabs or losing track of version history.",
  "seo.paragraph3": "Built by sourcing professionals who understand the chaos of cross-border e-commerce, OOPBUY Spreadsheet bridges the gap between raw data and smart business decisions. Join thousands of sellers who have already made the switch.",
  "seo.articles_heading": "In-Depth Guides & Comparisons",
  "seo.read_article": "Read Article",
  "seo.read_more": "Read Full Guide",
  "footer.brand": "OOPBUY",
  "footer.brand_sub": "Spreadsheets",
  "footer.description": "The smart spreadsheet system for e-commerce sourcing and inventory management. Built for sellers who value speed and accuracy.",
  "footer.newsletter_label": "Get Updates",
  "footer.newsletter_placeholder": "Your email address",
  "footer.subscribe": "Subscribe",
  "footer.copyright": "© 2026 OOPBUY Spreadsheets. All rights reserved.",
  "footer.quick_links": "Quick Links",
  "footer.column1_title": "Apparel",
  "footer.column2_title": "Accessories",
  "footer.column3_title": "More",
};
export default translation;